/**
 * 予約販売カウントダウン制御
 *
 * `buy-buttons.liquid` が出力する `data-sale-start-unix` を読み取り、
 * 販売開始日時までカートボタンを無効化し、カウントダウンバナーを表示する。
 */
(function () {
  "use strict";

  function getPresaleHelpers() {
    if (typeof window === "undefined" || !window.MFPresaleHelpers) return null;
    return window.MFPresaleHelpers;
  }

  function setupCountdown(productForm) {
    if (!productForm || productForm.__presaleCountdownInitialized) return;
    var helpers = getPresaleHelpers();
    if (!helpers || typeof helpers.getPresaleCountdownState !== "function") return;

    var saleStartUnix = productForm.dataset.saleStartUnix;
    var initialState = helpers.getPresaleCountdownState({
      saleStartUnix: saleStartUnix,
      nowMs: Date.now(),
    });
    if (!initialState.hasSaleStart) return;
    var banner = productForm.querySelector("#presale-countdown-banner");
    var countdownText = banner
      ? banner.querySelector(".presale-banner__countdown")
      : null;
    var intervalId = null;

    function applyLockedState(locked) {
      if (typeof productForm.setPresaleLocked === "function") {
        productForm.setPresaleLocked(locked);
      } else {
        productForm.dataset.presaleLocked = locked ? "true" : "false";
        var submitBtn = productForm.querySelector('button[name="add"], .product-form__submit, [id^="ProductSubmitButton"]');
        if (submitBtn) {
          submitBtn.classList.toggle("presale-disabled", locked);
          if (locked) {
            submitBtn.setAttribute("disabled", "disabled");
          } else {
            submitBtn.removeAttribute("disabled");
          }
        }
      }
    }

    function tick() {
      var countdownState = helpers.getPresaleCountdownState({
        saleStartUnix: saleStartUnix,
        nowMs: Date.now(),
      });
      var locked = countdownState.isLocked;

      applyLockedState(locked);

      if (locked) {
        if (banner) {
          banner.style.display = "";
        }
        if (countdownText && typeof helpers.formatPresaleRemaining === "function") {
          countdownText.textContent = helpers.formatPresaleRemaining(countdownState.diffMs);
        }
      } else {
        if (banner) {
          banner.style.display = "none";
        }
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }
    }

    productForm.__presaleCountdownInitialized = true;
    tick();
    if (initialState.isLocked) {
      intervalId = setInterval(tick, 1000);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll("product-form[data-sale-start-unix]");
    for (var i = 0; i < forms.length; i++) {
      setupCountdown(forms[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("product-info:loaded", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
